import React from 'react'
import PropTypes from 'prop-types'

import theme from './RejectionIconButton.scss'
import CSSModules from 'react-css-modules'
import {Button} from 'react-toolbox/lib/button'

const RejectionIconButton = (props) => (
  <Button 
    mini
    inverse 
    floating
    icon="close" 
    onClick={props.onClick} 
    theme={theme}
  />
)

RejectionIconButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default CSSModules(RejectionIconButton, theme)
